import { AlertTriangle, Inbox, RefreshCw, WifiOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";

export function EmptyState({ icon: Icon = Inbox, title, description, action, testId = "empty-state" }) {
  return (
    <div className="card flex flex-col items-start gap-3 p-6 md:p-8" data-testid={testId}>
      <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent text-primary"><Icon className="h-5 w-5" /></span>
      <div>
        <h3 className="text-base font-semibold text-slate-900">{title}</h3>
        {description && <p className="mt-1 max-w-prose text-sm text-slate-600">{description}</p>}
      </div>
      {action}
    </div>
  );
}

export function Loading({ rows = 5, testId = "loading-state" }) {
  return (
    <div className="space-y-3" data-testid={testId} aria-busy="true" aria-label="Caricamento in corso">
      {Array.from({ length: rows }).map((_, i) => <Skeleton key={i} className="h-10 w-full rounded-md bg-slate-200/70" />)}
    </div>
  );
}

export function ErrorState({ message, onRetry, testId = "error-state" }) {
  const offline = !navigator.onLine;
  return (
    <div className="card flex flex-col items-start gap-3 border-[#A13544]/30 p-6" role="alert" data-testid={testId}>
      <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#FEE2E2] text-[#A13544]">
        {offline ? <WifiOff className="h-5 w-5" /> : <AlertTriangle className="h-5 w-5" />}
      </span>
      <div>
        <h3 className="text-base font-semibold text-slate-900">{offline ? "Sei offline" : "Qualcosa non ha funzionato"}</h3>
        <p className="mt-1 text-sm text-slate-600">{message}</p>
      </div>
      {onRetry && <Button variant="outline" onClick={onRetry} data-testid="retry-button"><RefreshCw className="h-4 w-4" /> Riprova</Button>}
    </div>
  );
}

export function PageHeader({ title, subtitle, actions, testId }) {
  return (
    <div className="mb-5 flex flex-col gap-3 md:flex-row md:items-end md:justify-between" data-testid={testId}>
      <div>
        <h1 className="page-title">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-slate-600">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}

export function KeyValue({ label, value, testId }) {
  return (
    <div className="flex flex-col gap-0.5" data-testid={testId}>
      <span className="text-xs font-medium uppercase tracking-wide text-slate-500">{label}</span>
      <span className="tnum text-sm font-semibold text-slate-900">{value}</span>
    </div>
  );
}
